import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { LoaderService } from 'app/loader.service';
import { HubService } from 'app/hub.service';
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment';

@Component({
  selector: "app-cauth",
  templateUrl: "./cauth.component.html",
  styleUrls: ["./cauth.component.scss"],
})
export class CauthComponent implements OnInit {
  model: any = {};

  constructor(
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private hubService: HubService,
    private http: Http,
    private router: Router
  ) {}

  ngOnInit() {
    this.loaderService.setLoaded();
    let model = {};

    let action = this.route.snapshot.params.action;
    this.model.action = action;

    if (action == "callback") {
      this.login();
    }
  }

  /**
   * ---------------------------------------------
   * Log a user in on callback from Cognito hosted UI login
   * ---------------------------------------------
   */

  private login() {
    this.route.fragment.subscribe((fragment: string) => {
      this.model.id_token = new URLSearchParams(fragment).get('id_token');
    })

    this.getParseToken(this.model.id_token).subscribe(
      (response) => {
        this.router.navigate(["/become/" + response.token]);
      },
      (error) => {
        console.log("error: ", error);
      }
    );
  }

  /**
   * ---------------------------------------------
   * Get a Parse token using the JWT returned by Cognito
   * @param {String} cognitoToken - the id_token portion of the JWT token
   * @returns {String} - parse session token
   * ---------------------------------------------
   */
  private getParseToken(cognitoToken: String) {
    let headers = new Headers();
    headers.append("X-Parse-Application-Id", environment.parse.appId);
    headers.append("X-Parse-Javascript-Key", environment.parse.jsKey);
    headers.append("Authorization", "Bearer " + cognitoToken);
    let options = new RequestOptions({ headers: headers });

    // return the requst response
    return this.http
      .get(environment.parse.apiUrl + "/custom/session", options)
      .map((res) => res.json() || {})
      .catch(this.errorHandler);
  }

  /**
   * ---------------------------------------------
   * Handle and return formatted error
   * @param {Object} error - the error
   * @returns {String} - formatted error
   * ---------------------------------------------
   */
  private errorHandler(error: Response | any): Observable<any> {
    let errMsg: string;

    // build a generic error message to use if we dont define something specific
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    // specific error messages
    if (error.status == 401) {
      // unauthorised
      errMsg = "You do not have permission to perform this action (401 Error)";
    } else if (error.status == 400) {
      // bad request
      errMsg = "You do not have permission to perform this action (400 Error)";
    } else if (error.status == 500) {
      // internal server error
      errMsg = "Internal Server error (400 Error)";
    } else if (error.status == 404) {
      // not found error
      errMsg = "Sorry, we couldn't find that record (404 Error)";
    }

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/cauth/cauth.component.ts